getInternalIteratorState